import React, { useState, useEffect, useMemo, useRef } from "react";

import { isNonEmpty, isNonEmptyArray } from "_helpers";
import { useFolderDetailGetMessageAttachment } from "_hooks";

import { Card, Col, Descriptions, Empty, Row, Tabs, Typography } from "antd";

import parse from 'html-react-parser';

import styles from "_styles/FolderDetail.module.css";

export function Contacts({ fetchData }){
    const [ descriptionsItems, setDescriptionsItems ] = useState([]);

    const [ activeKey, setActiveKey ] = useState("0");

    const [ contactDetailDescriptionsItems, setContactDetailDescriptionsItems ] = useState([]);
    const [ firstContactBlocEmHeight, setFirstContactBlocEmHeight ] = useState(0);

    const DescriptionsItem = Descriptions.Item;
    const firstContactBlocRef = useRef();

    const { setBinId } = useFolderDetailGetMessageAttachment();

    const { Text, Link } = Typography;

    const labelStyle = useMemo(() => ({ width: '200px' }), []);

    const descriptionsItemsModel = useMemo(() => ({
        'soc_txt': 'Entité',
        'acc_id': 'N° de compte',
        'acc_txt': 'Nom',
        'acc_siret': 'SIRET/SIREN'
    }), [])

    const contactDetailDescriptionsItemsModel = useMemo(() => ({
        'adr_postal': 'Adresse',
        'adr_email': 'E-mail',
        'adr_tel': 'Téléphone'
    }), [])

    const tabsItems = useMemo(() => ([
        {
            key: "0",
            label: "Commentaires",
            children: (
                <Row className="h-100 flex-column">
                    <Col className="h-50">
                        <span>Commentaire reporting</span>
                        <Card className="mt-1 d-flex text-break" style={{ height: "calc(100% - 30px)", overflowY: "auto" }}>
                            { parse(fetchData?.notepad_txt_report || "") }
                        </Card>
                    </Col>
                    <Col className="h-50">
                        <span>Commentaire actions externes</span>
                        <Card className="mt-1 d-flex text-break" style={{ height: "calc(100% - 30px)", overflowY: "auto" }}>
                            { parse(fetchData?.notepad_txt_litig || "") }
                        </Card>
                    </Col>
                </Row>
            )
        },
        {
            key: "1",
            label: "Coordonnées",
            children: (
                <Descriptions column={1} bordered size="small" className="h-100">
                    {
                        contactDetailDescriptionsItems.map(item => {
                            const { key, label, children } = item;
                            return (
                                <DescriptionsItem key={key} label={label} labelStyle={labelStyle}>
                                    <span className="d-flex">
                                        {children}
                                    </span>
                                </DescriptionsItem>
                            );
                        })
                    }
                </Descriptions>
            )
        },
        {
            key: "2",
            label: "Fichiers",
            children: (
                <>
                    {
                        fetchData?.attachments && isNonEmpty(fetchData.attachments)
                            ?
                                fetchData.attachments.map((el,idx) => {
                                    return (
                                        <div key={idx} className="mt-2">
                                            <Text className={styles.contactsLink} onClick={() => setBinId(el.bin_id)}>{el.bin_name}</Text>
                                            <div className="ms-2">
                                                <Text italic style={{ color: 'grey' }}>{el.bin_desc}</Text>
                                            </div>
                                        </div>
                                    );
                                })
                            :
                                <Empty />
                    }
                </>
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ]), [fetchData, activeKey, setBinId])

    useEffect(() => {
        let tempData = [], tempData2 = [];
        
        Object.entries(fetchData).forEach(([key, value]) => {
            if( descriptionsItemsModel[key] ){
                tempData.push({
                    key,
                    label: descriptionsItemsModel[key],
                    children: value || '[N/C]'
                })
            }

            if( contactDetailDescriptionsItemsModel[key] ){
                tempData2.push({
                    key,
                    label: contactDetailDescriptionsItemsModel[key],
                    children: value || '[N/C]'
                })
            }
        })

        setDescriptionsItems(tempData);
        setContactDetailDescriptionsItems(tempData2);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData])

    useEffect(() => {
        if (!firstContactBlocRef.current) return;
    
        const observer = new ResizeObserver(() => {
            const el = firstContactBlocRef.current;
            if( !el ) return;

            const heightPx = el.offsetHeight;
            const fontSizePx = parseFloat(getComputedStyle(el).fontSize);

            if( fontSizePx > 0 ) {
                const heightEm = heightPx / fontSizePx;
                setFirstContactBlocEmHeight(56 - heightEm);
            } else setFirstContactBlocEmHeight(42);
        });
    
        observer.observe(firstContactBlocRef.current);
    
        return () => observer.disconnect();
    }, [descriptionsItems, contactDetailDescriptionsItems]);

    const handleTabsChange = ( key ) => {
        setActiveKey(key);
    }

    return (
        <>
            {
                isNonEmptyArray(descriptionsItems) && isNonEmptyArray(contactDetailDescriptionsItems) 
                &&
                    <Card className="h-100" bodyStyle={{height: '100%'}}>
                        <Row>
                            <Col className="w-100" ref={firstContactBlocRef}>
                                <Descriptions title={("Informations").toUpperCase()} column={1} bordered size="small">
                                    {
                                        descriptionsItems.map(item => {
                                            const { key, label, children } = item;
                                            return (
                                                <DescriptionsItem key={key} label={label} labelStyle={labelStyle}>
                                                    <span className="d-flex">
                                                        {children}
                                                    </span>
                                                </DescriptionsItem>
                                            );
                                        })
                                    }
                                </Descriptions>
                            </Col>
                            <Col className="w-100">
                                <Tabs 
                                    items={tabsItems} 
                                    activeKey={activeKey} 
                                    className={styles.contactsTabs} 
                                    style={{ height: `${firstContactBlocEmHeight}em` }} 
                                    onChange={handleTabsChange}
                                />
                            </Col>
                        </Row>
                    </Card>
            }
        </>
    );
}